import { ArrowUpCircleIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import * as XLSX from "xlsx";
import React, { useState, useEffect, useRef } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import AddButton from "../../../../components/AddButton";
import ButtonForModal from "../../../../components/ButtonForModal";
import { useHistory, useLocation } from "react-router-dom";
import { PrinterIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import {
  leShowState,
  ledAddState,
  ledEditState,
  rowForEditLeasedEquipment,
  selectedRowsLE,
  leFromOffice,
  lEViewData,
  leasedEquipmentOfficeId,
  vendorLeasedId,
  disableLEVendorField,
  leFromVendor,
} from "../atom/atom";
// import { LeasedEquipmentForm } from "../forms/LeasedEquipmentForm";
import { useGetLeasedEquipment } from "../hooks/useGetLeasedEquipment";
import { LeasedEquipmentRowDetails } from "./LeasedEquipmentRowDetails";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useDeleteLE } from "../hooks/useDeleteLeasedEquipment";
import DownloadButton from "../../../../components/DownloadButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { mainSelectedTab, paginationData } from "../../atoms";
import { useGetLeasedEquipmentForEdit } from "../hooks/useGetLeasedEquipmentForEdit";
import { toast } from "../../../../components/toastNotification";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import useGetLeasedEquipmentForDownload from "../hooks/useGetLeasedEquipmentForDownload";
import { vendorViewId } from "../../Vendor/atoms/atoms";
import { useQueryClient } from "react-query";
import MassUploadButton from "components/MassUploadButton";
import { MassUpload } from "../massupload/MassUpload";
import { LeasedEquipmentForm } from "../forms/LeasedEquipmentForm";
import MassUploadDropdown from "components/MassUploadDropdown";

interface LeasedEquipmentTableProps {
  officeId?: string | number;
  viewFromOffice?: boolean;
  leasedEquipmentId?: number;
  viewFromVendor?: boolean;
}

export const LeasedEquipmentTable: React.FC<LeasedEquipmentTableProps> = ({
  viewFromOffice,
  leasedEquipmentId,
  viewFromVendor = false,
}) => {
  const [isAdd, setIsAddState] = useRecoilState(ledAddState);
  const [isEdit, setIsEditState] = useRecoilState(ledEditState);
  const [, setIsSearching] = useState(false);
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsLE);
  const queryClient = useQueryClient();
  const {
    mutate: BulkDeleteLeasedEquipments,
    isSuccess: deacSuccess,
    data: deacResult,
    reset: resetDeacData,
  } = useDeleteLE();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [, setFilter] = useState(false);
  const [isShow, setShowState] = useRecoilState(leShowState);
  const setRowToEdit = useSetRecoilState(rowForEditLeasedEquipment);
  const [rowViewData, setRowViewData] = useRecoilState(lEViewData);
  const [, setSearchId] = useState("");
  const [recordNumber, setRecordNumber] = useState("");
  const [displayNote] = useState(false);
  const [filteredLeasedEquipment, setFilteredLeasedEquipment] = useState<any[]>(
    []
  );
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const {
    data: leasedEquipment,
    isLoading: leLoading,
    status: leStatus,
  } = useGetLeasedEquipment();

  const {
    mutate: getLEForDownload,
    isLoading: getLELoading,
    isSuccess,
  } = useGetLeasedEquipmentForDownload();

  const [leData, setLEData] = useState<any[]>([]);
  const [showFromOffice, setShowFromOffice] = useRecoilState(leFromOffice);
  const [leOfficeId] = useRecoilState(leasedEquipmentOfficeId);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const { mutate: getLEForEdit } = useGetLeasedEquipmentForEdit();
  const [page, setPage] = useRecoilState(paginationData);
  let recordIdFromRecent;
  let location = useLocation();
  const history = useHistory();
  const [massUploadModal, setMassUploadModal] = useState(false);
  const [vendorMassUploadModal, setVendorMassUploadModal] = useState(false);

  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_leasedequipment_add;
  const editPermission = PERMISSIONS.permission_leasedequipment_edit;
  const deletePermission = PERMISSIONS.permission_leasedequipment_delete;
  const tableRef = useRef<any>([]);

  const [leVendorId, setVendorLeasedId] = useRecoilState(vendorLeasedId);
  const [, setDisableVendorField] = useRecoilState(disableLEVendorField);
  const [showFromVendor, setShowFromVendor] = useRecoilState(leFromVendor);

  const [vendorId, setVendorId] = useRecoilState(vendorViewId);

  const [exportdata, setExportdata] = useState([]);
  if (location.state !== null && location.state !== undefined) {
    recordIdFromRecent = location.state;
  }
  const handleEdit = (rowDetails) => {
    getLEForEdit(rowDetails?.recordNumber, {
      onSuccess: (res) => {
        setRowToEdit({
          ...res,
          leaseEndDate:
            res.leaseEndDate === null
              ? null
              : rowDetails.leaseEndDate.slice(0, 10),

          leaseStartDate:
            rowDetails.leaseStartDate === null
              ? null
              : rowDetails.leaseStartDate.slice(0, 10),

          returnedEquipmentDate:
            rowDetails.returnedEquipmentDate === null
              ? null
              : rowDetails.returnedEquipmentDate.slice(0, 10),

          cancellationDate:
            rowDetails.cancellationDate === null
              ? null
              : rowDetails.cancellationDate.slice(0, 10),

          isActive: !rowDetails.isActive,
        });
        setIsEditState(true);
      },
    });
  };
  useEffect(() => {
    if (recordIdFromRecent?.action === "fromVendorLE") {
      setVendorLeasedId(recordIdFromRecent?.vendorId);
      setDisableVendorField(true);
      setIsAddState(true);
      setShowFromVendor(true);
    }
    if (recordIdFromRecent?.action === "fromVendorLEEdit") {
      setVendorLeasedId(recordIdFromRecent?.vendorId);
      setDisableVendorField(true);
      handleEdit(recordIdFromRecent?.rowDetails);
      setShowFromVendor(true);
    }
    if (recordIdFromRecent?.action === "fromVendorViewLE") {
      setRowViewData(recordIdFromRecent?.vendorData);
      setShowState(true);
      setShowFromVendor(true);
      setVendorId(recordIdFromRecent?.vendorData?.vendorId);
    }
  }, [recordIdFromRecent]);

  const handleLink = (moduleName) => {
    const url = `/officesettings/${moduleName}`;
    history.push(moduleName);
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });

    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  // redirection back to vendor
  const handleLinkVendor = () => {
    const url = `/officesettings/leasedequipment`;
    history.push({
      pathname: `/vendortab/vendor`,
      state: {
        action: "leCancel",
        vendorId: leVendorId ? leVendorId : vendorId,
      },
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });

    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  const onClickRecordNumber = (rowData) => {
    setShowState(true);
    setRowViewData(rowData);
  };

  const onClickCancelShow = () => {
    if (showFromOffice) {
      setShowFromOffice(false);
      handleLink("officesetting");
    }
    if (showFromVendor) {
      setShowFromVendor(false);
      handleLinkVendor();
    }
    setShowState(false);
    setLEData(leData.map((data) => ({ ...data })));
    setFilteredLeasedEquipment([]);
    if (filteredLeasedEquipment?.length > 0) {
      setFilteredLeasedEquipment(
        filteredLeasedEquipment?.map((data) => ({ ...data }))
      );
    }
  };

  useEffect(() => {
    setSelectedRows([]);
  }, [setSelectedRows]);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });

    setSelectedRows(forDelete);
    setIsBulkSelected((prev) => !prev);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows
      ? selectedRows.map((row) => row.recordNumber)
      : undefined;
    BulkDeleteLeasedEquipments(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRows?.length
    } ${
      selectedRows
        ? selectedRows.length > 1
          ? "Leased Equipments"
          : "Leased Equipment"
        : undefined
    }?`}</div>
  );

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Leased Equipment were deactivated successfully",
        "success"
      );
      queryClient.invalidateQueries(["GetLeasedEquipment"]);
      setSelectedRows([]);
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Leased Equipment were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
        setSelectedRows([]);
      } else {
        toast.fire(
          "Bulk deactivation of Leased Equipment failed",
          "Server Error: Cannot deactivate Leased Equipment",
          "error"
        );
      }

      queryClient.invalidateQueries(["GetLeasedEquipment"]);
    } else {
      toast.fire(
        "Bulk deactivation of Leased Equipment failed",
        "Server Error: Cannot deactivate Leased Equipment",
        "error"
      );
      queryClient.invalidateQueries(["GetLeasedEquipment"]);
    }
    resetDeacData();
  }

  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;

  useEffect(() => {
    if (recordIdFromRecent !== "") {
      setIsSearching(true);
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setFilteredLeasedEquipment(result);
          setSearchId("");
          setFilter(true);
          setRecordNumber(recordIdFromRecent.recordId);
          history.push("/officesettings/leasedequipment");
        });
      } catch (error) {}
    } else {
      setFilteredLeasedEquipment([]);
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    // For multiple filter from notifcation/recent activity
    if (recordNumber?.includes(".")) {
      let recNum = recordNumber.split(".");
      const recNumArr = recNum.map((num) => Number(num));
      const filteredData = leasedEquipment?.data?.filter((x) =>
        recNumArr.includes(x.recordNumber)
      );
      setFilteredLeasedEquipment(filteredData);
      // For single filter from notifcation/recent activity
    } else if (recordNumber) {
      const filteredData = leasedEquipment?.data?.filter(
        (x) => x.recordNumber === Number(recordNumber)
      );
      setFilteredLeasedEquipment(filteredData);
    }
  }, [recordNumber, leasedEquipment?.data]);

  useEffect(() => {
    if (leStatus === "success") {
      if (leasedEquipment?.status === 200) {
        // From Office view all
        if (leOfficeId) {
          setFilteredLeasedEquipment(
            leasedEquipment?.data
              ?.filter((x) => x.officeId === leOfficeId)
              ?.map((data) => ({ ...data }))
          );
        } else {
          setLEData(leasedEquipment?.data?.map((data) => ({ ...data })));
        }
      } else {
        toast.fire(
          "Server Error",
          "Cannot retrieve Leased Equipment Data",
          "error"
        );
        setLEData([]);
      }
    }
  }, [leasedEquipment?.data, leStatus]);

  useEffect(() => {
    if (recordIdFromRecent?.action === "VendorCancel") {
      setShowState(true);
      setRowViewData(recordIdFromRecent.leasedEquipmentDetails);
    }
  }, [recordIdFromRecent]);

  const matColumns = [
    {
      title: "Record #",
      field: "recordNumber",
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => onClickRecordNumber(rowdata)}
          >
            <span className="blueAndBold underline">
              {"LE-" + String(rowdata.recordNumber)?.padStart(4, "0")}
            </span>
            <br></br>
          </div>
        );
      },
      customFilterAndSearch: (term, rowData) =>
        ("LE-" + String(rowData.recordNumber)?.padStart(4, "0"))
          .toLowerCase()
          .indexOf(term.toLowerCase()) !== -1,
    },
    {
      title: "Type",
      field: "typeName",
    },
    {
      title: "Make",
      field: "makeName",
    },
    {
      title: "Model/Version",
      field: "modelVersion",
      render: (rowDetails) => {
        return (
          <div className="flex items-center space-x-1 whitespace-normal ">
            {rowDetails?.modelDescription
              ? rowDetails?.model + " (" + rowDetails?.modelDescription + ")"
              : rowDetails?.model}
          </div>
        );
      },
    },

    {
      title: "Supply Alert Profile",
      field: "supplyAlertProfileName",
    },
    {
      title: "Equipment ID/Serial Number",
      field: "serialNumber",
      render: (rowDetails) => {
        return (
          <div className="flex items-center space-x-1 whitespace-normal ">
            {rowDetails.serialNumber}
          </div>
        );
      },
    },
    {
      title: "IP Address",
      field: "ipaddress",
    },
    {
      title: "Lease End Date",
      field: "leLeasedEndDate",
      render: (rowData) => {
        return <div>{rowData.leLeasedEndDate}</div>;
      },
    },
    // {
    //   title: "Vendor",
    //   field: "vendor",
    //   sorting: false,
    // },
    {
      title: "Servicing Dealer",
      field: "name",
    },
    {
      title: "Status",
      field: "status",

      render: (rowdata) => {
        return <div> {rowdata.status}</div>;
      },
    },

    {
      title: "Action",
      align: alignCenter,
      render: (rowData) => {
        return userPermissions.includes(editPermission) ? (
          <div className="flex place-content-center mr-4">
            <ButtonForModal
              className={
                rowData?.status?.includes("Closed")
                  ? "border border-quaternary text-white bg-quaternary opacity-50"
                  : "border border-quaternary text-white bg-quaternary"
              }
              onClick={() => {
                handleEdit(rowData);
              }}
              isDisabled={false}
            >
              <PencilSquareIcon className="h-4 w-4" />
              Edit
            </ButtonForModal>
          </div>
        ) : (
          ""
        );
      },
    },
  ];

  let prevPage = new URLSearchParams(window.location.search).get("prevPage");
  useEffect(() => {
    if (prevPage !== null && isAdd) {
      setPage(page);
    } else if (prevPage !== null && isEdit) {
      setPage(page);
    } else if (prevPage !== null && isShow) {
      setPage(page);
    } else if (prevPage !== null && showFromOffice) {
      setPage(page);
    } else if (prevPage !== null && showFromVendor) {
      setPage(page);
    } else if (prevPage !== null && tableRef.current !== Number(prevPage)) {
      tableRef.current = page;
    }
  });

  const convertToISODate = (date: string): string => {
    return new Date(date).toISOString().split("T")[0];
  };

  let dateTimeToday = convertToISODate(new Date().toISOString());

  const mapExportData = (): any => {
    const leData =
      tableRef.current.dataManager.searchText !== ""
        ? tableRef.current.dataManager.searchedData?.map((x) => x.recordNumber)
        : filteredLeasedEquipment?.length > 0
        ? filteredLeasedEquipment?.map((x) => x.recordNumber)
        : leasedEquipment?.data?.map((x) => x.recordNumber);
    getLEForDownload(leData, {
      onSuccess: (res) => {
        if (res)
          setExportdata(
            res[0]?.map((x) => {
              return {
                "Record Number": x.recordNumber,
                "Office Name": x.officeName,
                "Vendor Name": x.vendorStorageName,
                Type: x.typeName,
                Make: x.makeName,
                "Model/Version":
                  x?.model !== null
                    ? x?.model
                    : "" + " (" + x?.modelDescription !== null
                    ? x?.modelDescription
                    : "" + ")",
                "Equipment ID/Serial Number": x.serialNumber,
                "Supply Alert Profile": x.supplyAlertProfileName,
                "Customer Number": x.customerNumber,
                "Vendor Location No.": x.vendorLocationNumber,
                "Purchasing Vendor & Phone Number": x.purchasingVendorNumber,
                "Lease Amount": x.leaseAmount,
                "Previous Location": x.previousOfficeName,
                "Returned Equipment RM#": x.returnedEquipmentRm,
                "Returned Equipment Date": x.returnedEquipmentDate
                  ? new Date(x.returnedEquipmentDate)?.toLocaleDateString()
                  : "",
                "Tag Number": x.tagNumber,
                "IP Address": x.ipaddress,
                Status: x.status,
                IsActive: x.isActive,
                "Equipment Returned": x.equipmentReturned ? "True" : "False",
                "Lease Number": x.leaseNumber,
                "Lease Start Date": x?.leaseStartDate
                  ? new Date(x.leaseStartDate)?.toLocaleDateString()
                  : "",
                "Lease End Date": x?.leaseEndDate
                  ? new Date(x.leaseEndDate)?.toLocaleDateString()
                  : "",
                "Cancellation Date": x?.cancellationDate
                  ? new Date(x.cancellationDate)?.toLocaleDateString()
                  : "",
                "Servicing Dealer": x.name,
                "Servicing Dealer Phone Number": x.phone,
                "Service Dealer Email": x.email,
                "Toner Request Email": x.tonerRequestEmail,
                "Toner Request Phone": x.tonerRequestPhone,
                "Created By": x.createdBy,
                "Created Date": x.createdDate
                  ? new Date(x.createdDate)?.toLocaleDateString()
                  : "",
                "Last Modified By": x.lastModifiedBy,
                "Modified Date": x.modifiedDate
                  ? new Date(x.modifiedDate)?.toLocaleDateString()
                  : "",
                "File Name": x.fileNames,
              };
            })
          );
        toast.fire(
          "Download Leased Equipment ",
          "Successfully downloaded leased equipment.",
          "success"
        );
      },
      onError: (error) => {
        if (error) {
          toast.fire(
            "Download Leased Equipment ",
            "Server Error: Cannot download leased equipment.",
            "error"
          );
        }
      },
    });
  };
  useEffect(() => {
    if (isSuccess) {
      // For getting leased equipment details
      const leDownloadedFile = XLSX.utils.json_to_sheet(exportdata);
      const wb = XLSX.utils.book_new();

      // For additional sheet in excel
      const officeSheet = XLSX.utils.book_append_sheet(
        wb,
        leDownloadedFile,
        "LeasedEquipment_" + dateTimeToday
      );
      XLSX.writeFile(wb, "LeasedEquipment_" + dateTimeToday + ".xlsx");
    }
  }, [isSuccess]);

  return (
    <>
      <div className="px-8 py-4 min-h-fitmin-h-fit">
        {isAdd || isEdit ? (
          <LeasedEquipmentForm
            isAdd={isAdd}
            isEdit={isEdit}
            setIsAdd={setIsAddState}
            setIsEdit={setIsEditState}
            isModalEdit={false}
            isOffice={true}
          />
        ) : isShow || showFromOffice || showFromVendor ? (
          <div className="relative p-2 box-shadow border-quinary border-l-2">
            <LeasedEquipmentRowDetails
              viewFromOffice={viewFromOffice}
              rowData={rowViewData}
              rowIsExpanded={true}
              onClickCancelShow={onClickCancelShow}
              handleEdit={handleEdit}
              setIsAdd={setIsAddState}
            />
          </div>
        ) : (
          <div>
            <div className="flex justify-between items-center ">
              <div>
                <div className="flex gap-2 items-center">
                  <div>
                    <PrinterIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                  </div>
                  <div className="flex flex-col leading tight">
                    <h3 className="text-xs font-medium text-gray-500">
                      Leased Equipment Module
                    </h3>
                    <h1 className="mr-auto font-bold text-primary text-md uppercase">
                      ALL Leased Equipments
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-row justify-between py-2">
              {userPermissions.includes(deletePermission) && !displayNote ? (
                <div className="text-secondary italic text-xs3 ">
                  {!isEdit ? (
                    <div>
                      <p className="font-bold italic inline-block mr-1">
                        Note:{" "}
                      </p>
                      Tick the box to deactivate some data.
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              ) : (
                ""
              )}
              <div className="space-x-4 mr-6 mb-2"></div>
              <div className="gap-2 flex items-center">
                {userPermissions.includes(addPermission) ? (
                  <div>
                    <AddButton
                      className={"opacity-100"}
                      disabled={false}
                      buttonText="Add"
                      onClick={() => {
                        setIsAddState(true);
                      }}
                    />
                  </div>
                ) : (
                  ""
                )}
                {/* /////////mass upload */}
                {/* {userPermissions.includes(addPermission) && (
                  <MassUploadButton
                    onClickFunction={() => {
                      setMassUploadModal(true);
                    }}
                    className={
                      isAdd || isEdit
                        ? "hidden"
                        : "hover:scale-90 transition duration-500 bg-tranparent border-quaternary shadow-md hover:bg-quaternary text-quaternary group relative flex justify-center items-center py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70"
                    }
                  >
                    <ArrowUpCircleIcon className="h-4 w-4 mr-2" />
                    Mass Upload
                  </MassUploadButton>
                )} */}
                {/* mass upload dropdown */}
                {userPermissions.includes(addPermission) && (
                  <MassUploadDropdown
                    options={[
                      { label: "Office", value: "office" },
                      { label: "Vendor Storage", value: "vendor storage" },
                    ]}
                    defaultValue=""
                    onChangeFunction={(e) => {
                      const selected = e.target.value;
                      if (selected === "office") {
                        setMassUploadModal(true);
                      } else if (selected === "vendor storage") {
                        setVendorMassUploadModal(true);
                      }
                    }}
                  />
                )}
                <div className="box-content">
                  <DownloadButton
                    disabled={getLELoading}
                    buttonValue={
                      getLELoading ? "Downloading..." : "Download File"
                    }
                    onClick={() => {
                      mapExportData();
                    }}
                  />
                </div>
              </div>
            </div>
            <main className="flex flex-row">
              <div className="w-full mb-4 bg-white  overflow-x-auto box-shadow">
                <div className="grid grid-row">
                  {!isShow && (
                    <MaterialExTable
                      columns={matColumns}
                      data={
                        filteredLeasedEquipment?.length > 0
                          ? filteredLeasedEquipment
                          : leData
                      }
                      isLoading={leLoading}
                      search={viewFromOffice ? false : true}
                      selectedRows={selectedRows}
                      selection={userPermissions.includes(deletePermission)}
                      toolbar={true}
                      setOpenModal={setOpenModalDelete}
                      onSelectionChange={handleSelectedRowsChange}
                      actions={undefined}
                      editable={undefined}
                      exportButton={undefined}
                      grouping={undefined}
                      detailPanel={undefined}
                      toolBarComponent={undefined}
                      panelWidth={undefined}
                      tableRef={tableRef}
                      onSearchChange={undefined}
                      fileName={undefined}
                      title={undefined}
                      // options={{
                      //   toolbar: false,
                      //   showTitle: false,
                      //   initialPage: page,
                      // }}
                    />
                  )}
                </div>
              </div>
            </main>
          </div>
        )}
      </div>
      <ConfirmBoxDelete
        ModalTitle="Deactivate Leased Equipment"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={isBulkSelected ? handleBulkDelete : handleBulkDelete}
        cancelButtonRef={undefined}
      />
      {/* mass upload */}
      {massUploadModal && (
        <MassUpload
          isOpen={massUploadModal}
          setMassUploadModal={setMassUploadModal}
          mode="office"
          agmtRefetch={true}
        />
      )}

      <MassUpload
        isOpen={vendorMassUploadModal}
        setMassUploadModal={setVendorMassUploadModal}
        mode="vendor"
        agmtRefetch={true}
      />
    </>
  );
};
